import NoImageSrc from "@/assets/images/no_image.svg";
import { CLink } from "@/components/common/customLink/CustomLink";
import CldImage from "@/components/ui/cldImg/CldImage";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { BrandSingleCardProps } from "./types";
interface IProps extends BrandSingleCardProps {
  link: string;
}

const BrandSingleCard = ({ image, link, altText }: IProps) => {

  return (
    <CLink href={link} className="flex items-center justify-center w-[144px] md:w-full h-full md:h-36">
      <CldImage
        src={getCloudinaryURL(image) ?? NoImageSrc}
        alt={altText ?? "logo"}
        width={144}
        height={144}
        className="w-full h-auto max-w-[144px] max-h-[144px] object-contain"
      />
    </CLink>
  );
};

export default BrandSingleCard;